<template>
  <div><manage-order :showFilter="false"></manage-order></div>
</template>
<script>
import manageOrder from "@/components/orders/manageOrder";
export default {
  components: {
    "manage-order": manageOrder,
  },
};
</script>
<style></style>
